import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const SyncIcon = (props) => (
    <SvgIcon {...props}>
        <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.5 7.5C1.5 4.17198 4.14021 1.5 7.36547 1.5C9.52997 1.5 11.4294 2.70124 12.4464 4.5H10.5V6H15V1.5H13.5V3.34807C12.1827 1.33414 9.93107 0 7.36547 0C3.28345 0 0 3.37217 0 7.5H1.5Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.5 7.5C13.5 10.828 10.8598 13.5 7.63457 13.5C5.47004 13.5 3.57057 12.2988 2.55356 10.5H4.5V9H0V13.5H1.5V11.6519C2.81731 13.6659 5.06886 15 7.63457 15C11.7165 15 15 11.6278 15 7.5H13.5Z"
                fill="currentColor"
            />
        </svg>
    </SvgIcon>
);

export default SyncIcon;
